import React from 'react';
import { useSelector } from 'react-redux';

const ArticleThumb = ({ item }) => {
  return (
    <article class='row mb-30'>
      <div class='col-md-4'>
        <div class='post-thumb position-relative thumb-overlay'>
          <div
            class='img-hover-slide border-radius-5 position-relative'
            style={{
              backgroundImage: `url(${item.thumbnail})`,
            }}
          >
            <a
              class='img-link'
              href={`/${item.is_video_news === 1 ? 'tin-video' : 'tin-tuc'}/${
                item.slug
              }`}
            ></a>
          </div>
        </div>
      </div>
      <div class='col-md-8 align-center-vertical'>
        <div class='post-content'>
          <div class='entry-meta meta-0 font-small mb-15'>
            <a href={`tin-tuc/${item.slug_category}`}>
              <span
                class='post-cat background2 color-white'
                style={{
                  backgroundColor: item.background_color_category,
                }}
              >
                {item.name_category}
              </span>
            </a>
          </div>
          <h4 class='post-title'>
            <a
              href={`/${item.is_video_news === 1 ? 'tin-video' : 'tin-tuc'}/${
                item.slug
              }`}
            >
              {item.title}
            </a>
          </h4>
          <div class='entry-meta meta-1 font-small color-grey mt-15 mb-15'>
            <span class='post-on'>
              <i class='ti-marker-alt'></i>
              {item.scheduled}
            </span>
            {/* <span class='time-reading'>
              <i class='ti-timer'></i>10 mins read
            </span>
            <span class='hit-count'>
              <i class='ti-bolt'></i> 159k Views
            </span> */}
          </div>
          <p class='font-medium'>{item.short_description}</p>
        </div>
      </div>
    </article>
  );
};
export default ArticleThumb;
